<template>
    <div :class="['filters-block', (parent ? 'parent' : 'child')]">
        <div @click="toggle" :class="['header', {'show': showBody},{ 'small-header': smallHeader }, {empty}]">
            <h4>{{title}}</h4>
            <icon v-if="empty && showBody" name="close" class="icon" fill="var(--lighten-5-color)" />
            <icon v-else name="angle" class="icon" fill="var(--lighten-5-color)" />
        </div>
        <div v-if="showBody && !empty" class="body" :class="{ 'small-body': smallBody }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "filtersBlock",
        props: {
            title: {
                type: String,
                default: ""
            },
            parent: {
                type: Boolean,
                default: false
            },
            empty: {
                type: Boolean,
                default: false
            },
            smallHeader: {
                type: Boolean,
                default: false
            },
            smallBody: {
                type: Boolean,
                default: false
            },
            collapse: {
                type: Number,
                default: 0
            },
            open: {
                type: Number,
                default: 0
            },
            headlineCheckbox: {
                type: Object,
                default: () => ({})
            },
            showSelectedHotels: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showBody: false,
            }
        },
        methods: {
            toggle() {
                this.showBody = !this.showBody;
                this.$emit("toggle", this.showBody)
            }
        },
        watch: {
            collapse() {
                this.showBody = false
            },
            open: {
                handler(value){
                    if(value){
                        this.showBody = true
                    }
                },
                immediate: true
            },
        }
    }
</script>

<style scoped>

    .filters-block {
        background-color: var(--white-color);
    }
    .header {
        background-color: var(--lighten-6-color);
        padding: 18px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    .small-header {
        padding: 12px 16px;
    }
    .parent .header.show {
        background-color: var(--lighten-6-color);
    }
    .child .header.show {
        background-color: var(--primary-2-color);
    }
    .parent .header.show h4 {
        color: var(--primary-color);
    }
    .child .header.show h4 {
        color: var(--dark-1-color);
    }
    .header h4 {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: var(--dark-1-color);
    }
    .header .icon {
        transition: .2s all;
    }
    .header.show .icon {
        transform: rotate(180deg);
    }
    .parent .body {
        padding: 0;
    }
    .child .body {
        padding: 20px;
    }
    .child .small-body {
        padding: 14px 14px 6px 14px;
    }

</style>